<p *ngIf="candidateConflictDetails.conflictExists" class="text-danger">The existing contact details do not match the details in the Resume.</p>
<p *ngIf="!candidateConflictDetails.conflictExists">The existing contact details match the details in the Resume.</p>
<span *ngIf="candidateConflictDetails.additionalMatchRuleVerified">
    <p *ngIf="candidateConflictDetails.additionalMatchRuleVerificationPassed">
        Additional matching criteria of education and experience have been verified.
    </p>
    <p class="text-danger" *ngIf="!candidateConflictDetails.additionalMatchRuleVerificationPassed">
        Additional matching criteria of education and/or experience do not match.
    </p>
</span>
<p>Do you really want to update the Candidate Information with the details in the Resume?</p>
<p>Please select the details to be updated.</p>
<table class="table table-bordered table-responsive user-configuration-table">
    <thead>
        <tr>
            <th></th>
            <th></th>
            <th>Existing Candidate Details</th>
            <th>Candidate Details in Resume</th>
            <th>Candidate Details will be updated to:</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let field of candidateConflictDetails.candidateConflictDetails; let i = index">
            <td class="text-center">{{i + 1}}.</td>
            <td><span>{{field.fieldName}}</span></td>
            <td>
                <div class="comp-management-radio pt-2" style="display:inline-block">
                    <input type="radio" name="{{field.fieldId}}" id="{{field.fieldId}}-existing"
                        (change)="updateField(i, false)" [value]="false" [(ngModel)]="field.newValueSelected">
                    <label for="{{field.fieldId}}-existing" class="compare-candidate-radio-label">
                        {{field.oldValue}}
                    </label>
                </div>
            </td>
            <td>
                <div class="comp-management-radio pt-2" style="display:inline-block">
                    <input type="radio" name="{{field.fieldId}}" id="{{field.fieldId}}-new" (change)="updateField(i, true)"
                        [value]="true" [(ngModel)]="field.newValueSelected">
                    <label for="{{field.fieldId}}-new" class="compare-candidate-radio-label">
                        {{field.newValue}}
                    </label>
                </div>
            </td>
            <td>{{field.selectedValue}}</td>
        </tr>
    </tbody>
</table>
<div class="col-xs-12 text-right">
    <div class="clearfix">
        <button type="button" class="btn btn-danger" (click)="cancel()">
            <span>Cancel</span>
        </button>
        <button type="submit" class="btn btn-success" (click)="save()">
            <span>
                Update
            </span>
        </button>
    </div>
</div>
